/**
 * RelarkFounderAnchor
 * -------------------
 * Slim founder-anchor strip placed early on the page (right after the first
 * proof block, the Anders sample insight). One line + initial avatar.
 * The point is differentiation, not self-promotion: a Nordic skeptic gets
 * to know who built this BEFORE deciding whether to keep reading.
 *
 * The full founder section (RelarkFounderNote) still lives later in the
 * cascade — this is just the early anchor that points to it.
 */

import { useTranslation } from "react-i18next";
import { useScrollFadeIn, fadeCls } from "@/hooks/useScrollFadeIn";

export default function RelarkFounderAnchor() {
  const { t } = useTranslation("ui");
  const { ref, isVisible } = useScrollFadeIn(0.2);

  return (
    <section className="py-8 sm:py-10">
      <div ref={ref} className="mx-auto max-w-2xl px-5">
        <a
          href="#founder"
          className={`group flex items-start gap-4 rounded-xl border border-border/70 bg-card px-4 py-4 sm:px-5 sm:py-5 hover:border-primary/30 transition-colors ${fadeCls(isVisible)}`}
        >
          <div
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary font-bold text-base"
            aria-hidden
          >
            M
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[11px] font-semibold uppercase tracking-wider text-primary mb-1">
              {t("relark.founder.anchor.eyebrow")}
            </p>
            <p className="text-sm sm:text-base text-foreground/90 leading-relaxed">
              {t("relark.founder.anchor.line")}
            </p>
            <span className="mt-1.5 inline-block text-xs font-medium text-primary group-hover:underline underline-offset-4">
              {t("relark.founder.anchor.linkLabel")} →
            </span>
          </div>
        </a>
      </div>
    </section>
  );
}